module.exports = __webpack_public_path__ + "img/p3.920fb9b1.jpg";